"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonJsBundler = void 0;
/** Defines process.env: used by some libraries. */
const defineProcessEnv = 'const process = { env: {} };';
/** Defines global, used by typescript for global definitions. */
const defineGlobal = 'const global = globalThis;';
/** Defines CommonJs require() */
const defineRequire = `
const __modules = {};
function require(name) {
  const module = __modules[name];
  if (module === undefined) throw new Error(\`Cannot resolve module \${name}\`);
  return module;
}`;
/** Wraps a module inside a function that processes the exports and updates__modules */
function wrapModule(name, moduleCode) {
    return `
__modules['${name}'] = (() => {
    const exports = {};
    const module = {exports};
    ${moduleCode}
    return exports;
})();`;
}
/** Bundler that merges a list of CommonJs modules into a single file. */
class CommonJsBundler {
    bundle(modules) {
        return [
            defineProcessEnv,
            defineGlobal,
            defineRequire,
            ...Object.entries(modules).map(([key, value]) => wrapModule(key, value)),
        ].join('\n');
    }
}
exports.CommonJsBundler = CommonJsBundler;
//# sourceMappingURL=commonjs_bundler.js.map